import React from 'react';
import { DateTime } from 'luxon';

type DateCellProps = {
  value: string | null | undefined;
};

export const DateCell: React.FC<DateCellProps> = ({ value }) => {
  if (!value) return <span>—</span>;
  const dt = DateTime.fromISO(value, { zone: 'utc' });
  if (!dt.isValid) return <span>—</span>;
  return <span>{dt.toFormat('MM/dd/yyyy')}</span>;
};
